import moment from "moment";

import { CancellationCharge } from "shared/types/hotels";

const getSortedCancellationCharges = (
  charges: CancellationCharge[] = []
): CancellationCharge[] =>
  [...charges].sort(
    (chargeA, chargeB) =>
      moment(chargeA.FromDate).valueOf() - moment(chargeB.FromDate).valueOf()
  );

const getFirstPenaltyStartDate = (
  charges: CancellationCharge[] = []
): string | null => {
  const [firstCharge] = getSortedCancellationCharges(charges);
  return firstCharge?.FromDate || null;
};

const isPenaltyActive = (
  penaltyStartDate: string | null | undefined,
  currentDate = moment()
): boolean => {
  if (!penaltyStartDate) {
    return false;
  }

  return moment(penaltyStartDate).isSameOrBefore(currentDate, "day");
};

const isNonRefundableByCancellationCharges = (
  charges: CancellationCharge[] = [],
  currentDate = moment()
): boolean => isPenaltyActive(getFirstPenaltyStartDate(charges), currentDate);

export {
  getSortedCancellationCharges,
  getFirstPenaltyStartDate,
  isPenaltyActive,
  isNonRefundableByCancellationCharges,
};
